import { useSeoMetaData } from 'hooks';
import { BrowseSeoType } from 'types/seoType';
import getStaticSeo from '../../constants/staticSeo';

const useBrowseSeo = (): {
    loading: boolean;
    metaData: BrowseSeoType;
} => {
    const { loading, seoMetaData } = useSeoMetaData();

    const metaData = {
        ...getStaticSeo().browse,
        ...(seoMetaData?.title && { title: seoMetaData.title }),
        ...(seoMetaData?.description && {
            description: seoMetaData.description,
        }),
        ...(seoMetaData?.header && { header: seoMetaData.header }),
        ...(seoMetaData?.byline && { byline: seoMetaData.byline }),
    };

    return { loading, metaData };
};

export default useBrowseSeo;
